// Core imports
import GraniteError from 'granite-admin/utils/granite-error';

// Application imports
import commonApi from 'granite-admin/common/gateways/common-api.js';
async function getCountriesData() {
  try {
    const res = await commonApi.countryData();
    return res.results;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function getStatesData(pk) {
  try {
    const res = await commonApi.stateData(pk);
    return res.results;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function getConfig(eventEmitter, id) {
  try {
    const config = await commonApi.getConfig(id);
    eventEmitter.emit('CONFIG_FETCH_SUCCESS', config);
    return config;
  } catch (error) {
    eventEmitter.emit('CONFIG_FETCH_FAILURE');
    // throw new GraniteError(error.errors);
  }
}

async function getConfigByName(eventEmitter, name) {
  try {
    const config = await commonApi.getConfigByName(name);
    eventEmitter.emit('CONFIG_OPTION_FETCH_SUCCESS', config);
  } catch (error) {
    eventEmitter.emit('CONFIG_OPTION_FETCH_FAILURE');
    throw new GraniteError(error.errors);
  }
}
async function getFieldGroup(params) {
  try {
    let fieldGroup, childFields;
    fieldGroup = await commonApi.getFieldGroup(params);
    if (fieldGroup.length) childFields = await commonApi.getFieldGroup({
      parent_id: fieldGroup[0].pk
    });
    return {
      fieldGroup: fieldGroup || [],
      childFields: childFields || []
    };
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function postConfig(eventEmitter, params) {
  try {
    params.entity_name = params.entity_name.name;
    let res = await commonApi.postConfig(params);
    eventEmitter.emit('CONFIG_SAVED_SUCCESS', params.config_type.replace('_', '-').toLowerCase());
    return res;
  } catch (error) {
    eventEmitter.emit('CONFIG_SAVED_FAILURE', error?.errors?.title);
    throw error;
  }
}
async function deleteMasterConfig(pk) {
  return await commonApi.deleteMasterConfig(pk);
}
async function postFieldGroup(params) {
  try {
    let res = await commonApi.postFieldGroup(params);
    return res;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function postMasterValues(params) {
  return await commonApi.postMasterValues(params);
}
async function deleteMasterValues(pk) {
  return await commonApi.deleteMasterValues(pk);
}
async function getMasterConfigs(params) {
  try {
    const list = await commonApi.getAllMasterConfigs(params);
    return list;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function getApiEndPoints(eventEmitter) {
  try {
    const config = await commonApi.getConfigByName('api_services_list', {}, 'SYSTEM');
    if (config?.options?.length) {
      const resp = await Promise.all(config.options.map(async i => await commonApi.getApiEndPoints(i)));
      const data = parseDocsData(resp);
      eventEmitter.emit('API_END_POINTS_SUCCESS', data);
    } else eventEmitter.emit('API_END_POINTS_SUCCESS', {});
  } catch (error) {
    eventEmitter.emit('API_END_POINTS_FAILURE');
  }
}
async function getOptionsConfig(eventEmitter, params) {
  try {
    const resp = await commonApi.getMasterConfigurations(params);
    eventEmitter.emit('FETCH_CONFIG_SUCCESS', resp.results);
  } catch (error) {
    eventEmitter.emit('FETCH_CONFIG_FAILURE', error);
    throw error;
  }
}
async function getContentTypes(eventEmitter, params) {
  try {
    const resp = await commonApi.getContentTypes(params);
    eventEmitter.emit('CONTENT_TYPE_SUCCESS', resp.list);
  } catch (error) {
    eventEmitter.emit('CONTENT_TYPE_FAILURE', error.errors?.title);
  }
}
async function getContentType(eventEmitter, pk) {
  try {
    const resp = await commonApi.getContentType(pk);
    eventEmitter.emit('CONTENT_TYPE_DETAIL_SUCCESS', resp.list);
  } catch (error) {
    eventEmitter.emit('CONTENT_TYPE_DETAIL_FAILURE', error.errors.title);
  }
}
async function getUserAttributes(eventEmitter, params) {
  try {
    const resp = await commonApi.getUserAttributes(params);
    eventEmitter.emit('USER_ATTRIBUTES_SUCCESS', resp.results);
  } catch (error) {
    eventEmitter.emit('USER_ATTRIBUTES_FAILURE');
  }
}
async function uploadToS3(values, updater) {
  try {
    const {
      files,
      file_name,
      ext,
      ...rest
    } = values;
    let filePath = '';
    const res = await Promise.all(files.map(async file => {
      const obj = {
        file,
        file_name: files.length > 1 ? file.name.split('.')[0] : file_name,
        ext: files.length > 1 ? file.name.split('.')[1] : ext,
        ...rest
      };
      const doc = await upload(obj);
      if (!rest.donCallUpdater) {
        return await updater({
          logo: {
            pk: doc.pk
          }
        });
      } else {
        filePath = doc;
        return doc;
      }
    }));
    return rest.donCallUpdater ? filePath : res;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function upload({
  file,
  file_name,
  ext,
  target_object_id,
  target_content_type_name,
  donCallUpdater
}) {
  try {
    const {
      fields,
      url
    } = await commonApi.getS3Url(`${file_name}.${ext}`);
    const fileData = new FormData();
    Object.keys(fields).forEach(field => {
      fileData.append(field, fields[field]);
    });
    fileData.append('file', file);
    await commonApi.uploadS3(url, fileData);
    if (!donCallUpdater) {
      const payload = {
        document_name: file_name,
        document: fields['key'],
        target_object_id,
        target_content_type_name
      };
      const data = await commonApi.createFile(payload);
      return data;
    } else {
      return fields['key'];
    }
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function getCompanyTypes(eventEmitter) {
  try {
    const response = await commonApi.getCompanyTypes();
    eventEmitter.emit('COMPANY_TYPES_FETCH_SUCCESS', response);
  } catch (error) {
    eventEmitter.emit('COMPANY_TYPES_FETCH_FAILURE');
  }
}
async function getFieldGroupData(eventEmitter, name, config) {
  let data = {
    childFields: [],
    possibleOptions: {},
    config: null
  };
  try {
    if (name) {
      const {
        childFields
      } = await getFieldGroup({
        name
      });
      data.childFields = childFields.map(field => ({
        label: field.name,
        value: field.name
      }));
      //build visible options for child dropdown
      let keys = childFields.map(i => i.name);
      if (keys.length) {
        const configs = await getMasterConfigs({
          keys: JSON.stringify(keys)
        }); //build mapping of option
        configs.list.forEach(config => {
          data.possibleOptions[config.name] = config.options.map(i => config.config_master_light ? {
            name: i,
            pk: i
          } : i);
        });
      }
      if (config) data.config = parseFieldVisibility(config, data.possibleOptions);
    } else {
      if (config) data.config = parseFieldVisibility(config, {});
    }
    eventEmitter.emit('FIELD_GROUP_SUCCESS', data);
  } catch (e) {
    eventEmitter.emit('FIELD_GROUP_FAILURE', data);
  }
}
async function getParentOptions(eventEmitter) {
  try {
    const data = await commonApi.getFieldGroup();
    const fieldGroup = data.map(field => ({
      label: field.name + ' ' + (field?.entity_name ? `(${field?.entity_name})` : '') + ' ' + (field?.attribute_name ? '/ ' + field.attribute_name : ''),
      value: field?.pk
    }));
    eventEmitter.emit('FIELD_GROUP_GET_SUCCESS', fieldGroup);
    return fieldGroup;
  } catch (e) {
    eventEmitter.emit('FIELD_GROUP_FAILURE');
  }
}
const parseFieldVisibility = (data, possibleOptions) => {
  if (data.field_group_visibility && typeof data.field_group_visibility == 'object') {
    data.visible_children = {}; //build UI specific data structure
    Object.keys(data.field_group_visibility).forEach(key => {
      // loop thru each config options
      let option = data.field_group_visibility[key]; // get option name
      let childFields = [];
      if (option?.visible && Object.keys(option.visible).length) {
        Object.keys(option.visible).forEach(field => {
          //loop thru each visible fields
          childFields.push({
            // put fields in object
            visibility: 'Visible',
            visible_field: {
              label: field,
              value: field
            },
            visible_field_options: option.visible[field].visible_values.map(i => data.config_master_light ? {
              name: i,
              pk: i
            } : i),
            visible_field_possible_options: possibleOptions[field] ? possibleOptions[field] : []
          });
        });
      }
      if (option?.hidden && option.hidden.length) {
        option.hidden.forEach(field => {
          //loop thru each hidden fields
          childFields.push({
            // put fields in object
            visibility: 'Hidden',
            visible_field: {
              label: field,
              value: field
            },
            visible_field_options: [],
            visible_field_possible_options: possibleOptions[field] ? possibleOptions[field] : []
          });
        });
      }
      data.visible_children[key] = childFields;
    });
  }
  return data;
};
const parseDocsData = data => {
  let ret = {};
  data.forEach(i => {
    const service = Object.keys(i)[0];
    Object.keys(i[service]).forEach(api => {
      const resp_obj = i[service][api]?.get?.responses['200'].content['application/json'].schema.properties;
      const attr = Object.keys(resp_obj).map(p => ({
        label: p.replaceAll('_', ' ').capitalize(),
        value: p
      }));
      ret[`${service}/v1${api}`] = {
        response_object: resp_obj,
        attributes: attr
      };
    });
  });
  return ret;
};
export { getCountriesData, getStatesData, getConfig, deleteMasterConfig, postConfig, getMasterConfigs, getContentTypes, getContentType, getConfigByName, getFieldGroup, getOptionsConfig, uploadToS3, getCompanyTypes, getUserAttributes, getFieldGroupData, getParentOptions, postFieldGroup, postMasterValues, deleteMasterValues, getApiEndPoints };